export default function filterStarsPercent(value: number) {
  if (value >= 0 && value <= 5) {
    return String(Math.floor(value * 20))
  }

  return ''
}
